module.exports = __webpack_public_path__ + "img/tasks-icon.a8a61231.png";